import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { Nullable } from '@gov-nx/core/types';
import type { PageCode } from '../../definitions/codes';
import type { NastaveniKontaktniUdajeROSContextValue } from './context.types';
import { useROSContact } from './useROSContact';

export const NastaveniKontaktniUdajeROSContext =
	createContext<Nullable<NastaveniKontaktniUdajeROSContextValue>>(null);

type NastaveniKontaktniUdajeROSContextProviderProps = PropsWithChildren<{
	code: PageCode;
}>;

export const NastaveniKontaktniUdajeROSContextProvider = ({
	children,
}: NastaveniKontaktniUdajeROSContextProviderProps) => {
	const { isLoading, error, rosContacts } = useROSContact();

	return (
		<NastaveniKontaktniUdajeROSContext.Provider
			value={{
				initialState: {
					isLoading,
					error,
				},
				rosContacts,
			}}>
			{children}
		</NastaveniKontaktniUdajeROSContext.Provider>
	);
};

export const useNastaveniKontaktnichUdajuROSContext =
	(): NastaveniKontaktniUdajeROSContextValue =>
		useContext(
			NastaveniKontaktniUdajeROSContext
		) as NastaveniKontaktniUdajeROSContextValue;
